import { useState } from "react";
import { useTranslation } from "react-i18next";

import { client } from "@/config/client";
import { useAppNotification } from "@/modules/app-notification";

export const useUpload = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { notify } = useAppNotification();

  const handleUpload = ({ file }) => {
    setLoading(true);
    return client.user
      .upload(file)
      .catch(() => notify.error({ title: t("global:uploadFailed") }))
      .finally(() => setLoading(false));
  };

  return { loading, handleUpload };
};
